import React, { Component, Fragment } from "react";
import FormNew from "./FormNew";
import ButtonAppBar from "./appBar";
import { connect } from "react-redux";
import { ActionCreators } from "../actions";
import "../App.css";

 class CWDFormContainer extends Component {
  componentDidMount() {
    this.props.gaPageView("/new");
  }
  render() {
    return (
      <Fragment>
        <ButtonAppBar />
        <div className="container">
          <FormNew />
        </div>
      </Fragment>
    );
  }
}

export default connect(null, ActionCreators)(CWDFormContainer)



// WEBPACK FOOTER //
// ./src/components/FormContainer.jsx